var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploadWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.25,12c.41,0,.75-.33,.75-.75h0V6h2.74c.34,0,.62-.28,.62-.62,0-.17-.07-.33-.18-.44L8.43,.18c-.24-.23-.62-.23-.85,0L2.82,4.93c-.24,.24-.24,.64,0,.88,.12,.12,.28,.18,.44,.18h2.74v5.25c0,.41,.33,.75,.75,.75h2.5Zm6.75-.25c0-.41-.33-.75-.75-.75h-4.25v.25c0,.97-.78,1.75-1.75,1.75h-2.5c-.97,0-1.75-.78-1.75-1.75v-.25H.75C.34,11,0,11.33,0,11.74H0v3.5c0,.41,.33,.75,.75,.75H15.25c.41,0,.75-.33,.75-.75h0v-3.5Zm-3.88,2.75c0,.34-.28,.62-.62,.62-.34,0-.62-.28-.62-.62,0-.34,.28-.62,.62-.62,.34,0,.62,.28,.62,.62Zm2,0c0,.34-.28,.62-.62,.62-.34,0-.62-.28-.62-.62,0-.34,.28-.62,.62-.62,.34,0,.62,.28,.62,.62Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadWhite);
export default __webpack_public_path__ + "static/media/Icon-Upload-White.2c3779fa5d3a3f6c7e6392115a4a70f8.svg";
export { ForwardRef as ReactComponent };